// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import styles from './state_reset_password.module.less';
import styles_common from './form.module.less';
import cn from 'classnames';
import {t_states} from './types';
import {img_url} from '../img_url';
import {parse, qs_parse} from 'zurl';
import {Button} from '../../../../shared/button';
import etask from 'zetask';
import {perr, is_safe_redirect} from 'hola_pub_util';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {up} from './utils';
import verify_email from '/www/login/pub/verify_email.js';
import {Settings_context} from '../../settings_ctx';
import Chevron_left from '../../img/hola2023/icons/16/chevron_left.svg';

interface i_signup_check_email_props {
    go_to?: (type:t_states, direction?: number)=>void;
    email: string;
    get_enc_url?: ()=>string;
    on_verify?: ()=>void;
    full_footer?: boolean;
    img_set?: 'hola'|'toolip';
    support_email?: string;
}

export const State_signup_check_email = (props: i_signup_check_email_props)=>{
    const {theme} = useContext(Settings_context);
    const [loading, set_loading] = useState(false);
    const [resent, set_resent] = useState(false);
    useEffect(()=>{
        perr({id: 'www_verify_email_view', info: {email: props.email}});
        const interval = setInterval(()=>etask(function*(){
            const res = yield fetch(up+'/is_verified');
            if (!res || !res.verified)
                return;
            perr({id: 'www_verify_email_polling_success',
                info: {email: props.email}});
            if (props.on_verify)
                return void props.on_verify();
            const {next} = qs_parse(parse(props.get_enc_url()).query,
                {safe: true});
            location.href = next && is_safe_redirect(next) ?
                next : `https://${location.host}/cp`;
            clearInterval(interval);
        }), 1000);
        return ()=>clearInterval(interval);
    }, [props.email]);
    const resend = ()=>{
        if (loading)
            return;
        perr({id: 'www_verify_email_resend_click',
          info: {email: props.email}});
        etask(function*(){
            set_loading(true);
            this.on('finally', ()=>set_loading(false));
            yield verify_email.resend_verification_email({data: {
              email: props.email,
              from_login_form: true
            }});
            set_resent(true);
            set_loading(false);
            perr({id: 'www_verify_email_resent',
              info: {email: props.email}});
        });
    };
    const footer_cls = cn(theme.p3, theme.reg, styles.text);
    return <div className={styles.root}>
      {props.img_set == 'toolip' && <button
        className={styles_common.back_btn_in_corner} onClick={()=>{
          props.go_to('login_with_email', -1);
        }}><Chevron_left/></button>}
      <div className={styles.check_email}>
        {props.img_set=='toolip' ?
          <img src={img_url('pro/check_email.png')} width={152}
            height={128} className={cn(styles.img, 'lazyload')}
            alt="check_email"/> :
          <img src={img_url('hola2023/check_email.svg')} width={200}
            height={128} className={cn(styles.img, 'lazyload')}
            alt="check_email"/>}
        <div className={styles_common.head}>
          <p className={styles_common.login_signup_text}><b>Let's get you
            verified!</b></p>
        </div>
        <div className={styles.pad_content}>
          <p className={cn(theme.p3, theme.reg, styles.text)}>
            Almost done, just check the email that was sent
              to <span className={styles_common.underline}>{props.email}</span>
            <br/><br/>
            Then, just follow the super simple instructions, complete your
              registration, and you're in!
            {resent && <Fragment>
              <br/><br/>
              Please check your spam mailbox and look for an email with
              subject: <strong>"Verify your {props.img_set == 'toolip'
              ? 'Toolip' : 'Hola'} email address"</strong>
            </Fragment>}
          </p>
          <Button caption={'Resend email'} color={'white'}
            on_click={()=>{
              resend();
            }} disabled={loading} cls={styles.m32}/>
          {props.full_footer ? <p className={footer_cls}>
            Need help? Visit our <Link to="/support"
            className={styles_common.underline}>Help center</Link> or contact
            our friendly support team via the <Link to="/premium_support"
            className={styles_common.underline}>support page</Link>.
          </p> : <p className={footer_cls}>
            Problems? Contact us at <a href={`mailto:${props.support_email
              || 'help@hola.org'}`}
            className={styles_common.underline}>{props.support_email
              || 'help@hola.org'}</a>
          </p>}
        </div>
      </div>
    </div>;
};
